module.exports = __webpack_public_path__ + "static/media/Darkrai_gaussian2.cd1fc30d.png";